import {Helmet} from "react-helmet";
import {RouteHelper} from "../../route/RouteHelper";
import {
    RaikoBaseCardContainer,
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator, RaikoCustomSimpleActiveDeActiveChip, RaikoCustomTable,
    RaikoGridOneColumn, RaikoTableTitleContainer, showServerErrorMessage
} from "@moeindal/base-raiko-panel-components";
import React, {useEffect, useState} from "react";
import {css} from "@emotion/css";
import {MawakibService} from "../../serverService/mawakibService/MawakibService";
import {useNavigate} from "react-router-dom";

export default function MawakibServiceList() {

    let page = 0
    const size = 15

    const [numberOfItems, setNumberOfItems] = useState(0);
    const [mawakibServiceData, setMawakibServiceData] = useState([]);
    const [tableLoading, setTableLoading] = useState(false);
    const [pageCount, setPageCount] = useState(0)

    const service = new MawakibService()

    const navigate = useNavigate()

    useEffect(() => {
        if (typeof service !== 'undefined') {
            getMawakibServiceListFromServer()
        }
    }, []);


    function getMawakibServiceListFromServer() {
        setTableLoading(true)

        service.getMawakibServiceList(page, size)
            .then(response => {
                setPageCount(response.totalPage)
                setNumberOfItems(response.numberOfItems)
                setMawakibServiceData([])
                response.data.map((item, index) => {
                    setMawakibServiceData(prevState => [
                        ...prevState,
                        createMawakibTableRow(
                            item.id,
                            (page * size) + index + 1,
                            item.title,
                            item.enabled
                        )
                    ])
                })
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            setTableLoading(false)
        })

    }

    function handleChangePage(newPage) {
        page = newPage
        getMawakibServiceListFromServer()
    }

    function showMawakibDetails(id) {
        let _title = ""
        mawakibServiceData.map((item) => {
            if (item.id === id) {
                _title = item.title
            }
        })
        navigate(RouteHelper.MawakibServiceDetails.globalUrl.replace(":id", id),
            {state: {title: _title}, replace: false}
        )

    }


    return (
        <>
            <Helmet>
                <title>{RouteHelper.MawakibServiceList.name}</title>
            </Helmet>
            <RaikoBaseContainer>
                <RaikoGridOneColumn className={css`gap: 1.5rem`}>
                    <RaikoBreadcrumb
                        breadCrumbItems={[
                            raikoBreadCrumbItemGenerator(
                                RouteHelper.MawakibManager.name,
                                ""
                            ),
                            raikoBreadCrumbItemGenerator(
                                RouteHelper.MawakibServiceList.name,
                                ""
                            ),
                        ]}/>
                    <RaikoBaseCardContainer>
                        <RaikoGridOneColumn>
                            <RaikoTableTitleContainer
                                title={RouteHelper.MawakibServiceList.name}
                                amount={numberOfItems}
                            />
                            <RaikoCustomTable
                                header={mawakibServiceTableHeader}
                                data={mawakibServiceData}
                                isLoading={tableLoading}
                                pageCount={pageCount}
                                rowClicked={showMawakibDetails}
                                handlePaginationChange={handleChangePage}
                            />
                        </RaikoGridOneColumn>
                    </RaikoBaseCardContainer>
                </RaikoGridOneColumn>
            </RaikoBaseContainer>

        </>
    )
}

function createMawakibTableRow(id, number, title, enabled) {
    return {
        id,
        number,
        title,
        enabled: <RaikoCustomSimpleActiveDeActiveChip state={enabled} activeStateTitle={"فعال"}
                                                      deActiveStateTitle={"غبر فعال"}/>
    }

}

const mawakibServiceTableHeader = [
    {
        id: "number",
        label: "#",
    },
    {
        id: "title",
        label: "عنوان",
    },
    {
        id: "enabled",
        label: "وضعیت",
    },

]